// extracted by mini-css-extract-plugin
export default {"container":"MobileAboutUsScreen_container__IpZMP","gaplessBox":"MobileAboutUsScreen_gaplessBox__1u3D5"};